import { render, staticRenderFns } from "./request-feature.vue?vue&type=template&id=1a31bbb0&"
import script from "./request-feature.vue?vue&type=script&lang=js&"
export * from "./request-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports